import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import { styled } from "@mui/system";
import { useField } from "formik";
import { Translate } from "@/components/Application/Translate";
import { Checkbox } from "@mui/material";

type Props = {
  label: string;
  name: string;
  id: string;
  type: string;
  placeholder?: string;
  translationString?: string;
  disabled?: boolean;
};

const StyledFormControlLabel = styled(FormControlLabel)`
  // CSS styles go here
`;

const CustomCheckbox = ({ label, translationString, ...props }: Props) => {
  const [field, meta, helpers] = useField(props.name);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    helpers.setValue(event.target.checked);
  };

  const hasError = meta.touched && meta.error;

  return (
    <div className="input-container">
      <StyledFormControlLabel
        control={
          <Checkbox
            {...props}
            checked={field.value}
            onChange={handleChange}
          />
        }
        label={
          <Translate String={translationString || ""}>
            {label}
          </Translate>
        }
        className={hasError ? "input-error" : ""}
      />
      {hasError && <div className="error">{meta.error}</div>}
    </div>
  );
};

export default CustomCheckbox;
